import { motion, AnimatePresence } from 'framer-motion'
import Image from 'next/image'

import styles from './Signup.module.css'

const SignupImage = ({ step }) => {
  return (
    <div>
      <AnimatePresence initial={false}>
        <motion.div
          key={step}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duraton: 1 }}
        >
          <Image
            src={step.image}
            alt="Sigup Image"
            layout="fill"
            objectFit="cover"
            objectPosition="50% 50%"
            quality={80}
            priority
          />
        </motion.div>
      </AnimatePresence>
    </div>
  )
}

export default SignupImage
